import React, { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./cursor.css";

const Cursor = ({ ready = true }) => {
  const reduce = useReducedMotion();
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hover, setHover] = useState(false);
  const [visible, setVisible] = useState(false);
  const [down, setDown] = useState(false);

  useEffect(() => {
    if (!ready || reduce) return undefined;
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;

    document.documentElement.classList.add("has-custom-cursor");

    const onMove = (event) => {
      setPos({ x: event.clientX, y: event.clientY });
      setVisible(true);
    };
    const onLeave = () => setVisible(false);
    const onOver = (event) => {
      const target = event.target.closest(
        "a, button, input, textarea, label, .btn, [role='button']"
      );
      setHover(Boolean(target));
    };
    const onDown = () => setDown(true);
    const onUp = () => setDown(false);

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    document.addEventListener("mouseleave", onLeave);
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);

    return () => {
      document.documentElement.classList.remove("has-custom-cursor");
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseleave", onLeave);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
    };
  }, [ready, reduce]);

  if (!ready || reduce) return null;

  return (
    <div className="cursor-layer" aria-hidden="true">
      <motion.div
        className={`cursor-dot${visible ? " is-visible" : ""}${hover ? " is-hover" : ""}`}
        animate={{
          x: pos.x,
          y: pos.y,
          scale: down ? 0.7 : hover ? 1.35 : 1,
          opacity: visible ? 1 : 0,
        }}
        transition={{ type: "spring", stiffness: 520, damping: 32, mass: 0.2 }}
      />
      <motion.div
        className={`cursor-frame${visible ? " is-visible" : ""}${hover ? " is-hover" : ""}`}
        animate={{
          x: pos.x,
          y: pos.y,
          scale: down ? 0.82 : hover ? 1.7 : 1,
          opacity: visible ? 1 : 0,
          rotate: 45,
        }}
        transition={{ type: "spring", stiffness: 200, damping: 24, mass: 0.35 }}
      >
        <span className="cursor-corner cursor-corner--tl" />
        <span className="cursor-corner cursor-corner--tr" />
        <span className="cursor-corner cursor-corner--bl" />
        <span className="cursor-corner cursor-corner--br" />
      </motion.div>
    </div>
  );
};

export default Cursor;
